'use strict';

var React = require('react');
var uniqueId = require('lodash.uniqueid');

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const ForceTitleContext = /*#__PURE__*/React.createContext(false);
function Symbol(_ref) {
  let {
    className,
    symbol: _symbol,
    title: _title = "",
    description = "",
    role = "img",
    ...platformProps
  } = _ref;
  let useSymbolAsTitle = React.useContext(ForceTitleContext);
  let [path, symbol] = _symbol.replace(".svg", "").split("#");
  let uid = uniqueId(`${symbol}-`);
  let title = _title ? _title : useSymbolAsTitle ? symbol : "";
  let optionalAttrs = title || description ? {
    "aria-labelledby": [title && `title-${uid}`, description && `desc-${uid}`].filter(Boolean).join(" ")
  } : null;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: role,
    className: ["symbol", className].join(" ").trim()
  }, optionalAttrs, platformProps), title && /*#__PURE__*/React.createElement("title", {
    id: `title-${uid}`
  }, title), description && /*#__PURE__*/React.createElement("desc", {
    id: `desc-${uid}`
  }, description), /*#__PURE__*/React.createElement("use", {
    xlinkHref: `${path}.svg#${symbol}`
  }));
}

exports.ForceTitleContext = ForceTitleContext;
exports.Symbol = Symbol;
//# sourceMappingURL=index.js.map
